import {NgIf} from '@angular/common';
import {CommonModule} from '@angular/common';
import {AfterViewInit, OnChanges, OnInit} from '@angular/core';
import {Component, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {finalize, tap} from "rxjs";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import * as pdfGenerator from 'jspdf';
import JsBarcode from 'jsbarcode';
import {ChangeDetectorRef} from '@angular/core';

import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {CookieService} from "ngx-cookie-service";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {
    MatAccordion, MatExpansionModule,
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelTitle
} from "@angular/material/expansion";
import * as XLSX from 'xlsx';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../environments/environment';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { AnalyseService } from '../../../services/analyse-service/analyse.service';
import { ClientsService } from '../../../services/client-service/clients.service';
import { HandleErrorsService } from '../../../services/handle-erros/handle.errors.service';
import { MatriceService } from '../../../services/matrice-service/matrice.service';
import { ParametreService } from '../../../services/parametre-service/parametre.service';
import { SampleService } from '../../../services/sample-service/sample.service';
import { SampleStatusService } from '../../../services/sample-status-service/sample.status.service';
import { TerrrainService } from '../../../services/terrains-service/terrrain.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../_modal/dialog.service';
import { ShortClientDto } from '../../_models/client.dtos';
import { ShortMatriceDto } from '../../_models/matrice.dtos';
import { ShortParametreDto } from '../../_models/parametre-dtos';
import { SampleStatusDto } from '../../_models/Sample.status.dto';
import { SampleDTO } from '../../_models/sampleDTO';
import { TerrainDTO } from '../../_models/terrain.dto';
import { ShortTypeAnalyseDto } from '../../_models/type.analyse.dtos';
import { ApiService } from '../../_services/api.service';
import { Endpoints } from '../../endpoints';
import { AppUserDTO } from '../../_models/userDTO';
import { UserService } from '../../../services/user-service/user.service';
import { MatChipsModule } from '@angular/material/chips';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


@Component({
    selector: 'app-manage-users',
    standalone: true,
    providers: [TerrrainService,AnalyseService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, MatriceService, UserService, HandleErrorsService, ClientsService, SampleStatusService],
    imports: [MatExpansionModule,
    MatNativeDateModule,
    CommonModule,FormsModule,
    MatCardModule, MatMenuModule, MatButtonModule, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,
    MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox],
    templateUrl: './manage-users.component.html',
    styleUrl: './manage-users.component.scss'
})
export class ManageUsersComponent  implements OnInit, OnChanges, AfterViewInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    form: FormGroup;
    searchVal: string = ''
    dataSource: MatTableDataSource<AppUserDTO> = new MatTableDataSource<AppUserDTO>();
    selectedSamples: Set<AppUserDTO> = new Set<AppUserDTO>();
    isAllSamplesSelected: boolean = false

    displayedColumns: string[] = [
        //'id',
        'Username',
        'name',
        'prenom',
        'phone',    
        'site',      
        'email',
        'hiringDate',
        'address',
        'role',
        'departmentName',
        //'preleveur'
   
    ];
    roleList: string[] =['admin', 'samplers',  'site_supervisor', 'responsable_qualite','responsable_laboratoire','preleveur'];

    // Map des labels lisibles
    roleLabels: { [key: string]: string } = {
      'admin': 'Administrateur',
      'samplers': 'Laborantin',
      'site_supervisor': 'Chargé relation client',
      'responsable_qualite': 'Responsable Qualité',
      'responsable_laboratoire': 'Responsable Laboratoire',
      'preleveur': 'Préleveur'
    };

    columns: string[] = [...this.displayedColumns];

    loadingTable: boolean = true;
    loadingOT: boolean = false
    loadingPdfGen: boolean = false
    loadingRapport: boolean = false
    loadingExcel: boolean = false
    panelOpenState = false;
    creatingUser = false;
    toastr: any;

    ngOnInit() {
        this.fetchUserList()
        this.getColsCookie()
        this.loadDepartments();

    }

    constructor(
        private cookieService: CookieService,
        private sanitizer: DomSanitizer,
        private apiService: ApiService,
        private endpoints: Endpoints,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private userService: UserService,
        private sampleService:SampleService,
        private handleErrors: HandleErrorsService) {
        this.initializeForm();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }

    departments: any[] = [];

    loadDepartments() {
        this.sampleService.fetchDepartementList().subscribe({
        next: (res: any[]) => {
            this.departments = res;
            console.log('Liste des départements:', this.departments);
        },
        error: (err) => {
            console.error('Erreur lors du chargement des départements:', err);
        }
        });
  }
    
    initializeForm() {
        this.form = this.fb.group({
            id: [''],
            username: [''],
            password: [''],
            hiringDate: [''],
            site:[''],
            departmentIds: ['', Validators.required],
            name: ['', Validators.required],
            prenom: ['', Validators.required],
            email: ['', Validators.required],
           // preleveur: [false],
            phone: ['', Validators.required],
            address: ['', Validators.required],
            role: [[], Validators.required],
            image: [''], // ✅ Champ image en tant qu'URL


        });
    }
    ngAfterViewInit() {
        this.initializePaginatorAndSort()
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchVal
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';

    }
    getRoleLabelsString(roles: string[]): string {
      if (!roles || roles.length === 0) return '';
      return roles.map(role => this.roleLabels[role] || role).join(' - ');
    }

    existingSignature: any | null = null;

        /** ✅ Récupération et affichage des rôles correctement formatés */
        editUser(user: any) {
          console.log("Utilisateur sélectionné pour modification :", user);
      
          // Nettoyer et formater les rôles pour l'affichage
          let roles = user.roles ? user.roles.map((r: string) => r.replace('ROLE_', '').toLowerCase()) : [];
      
          this.form.patchValue({
              id: user.id,
              username: user.username,
              email: user.email,
              //preleveur: user.preleveur,
              name: user.name,
              prenom: user.prenom,
              phone: user.phone,
              address: user.address,
              site: user.site,
              hiringDate: user.hiringDate,
              role: roles,
              departmentIds: user.departmentIds || null,  
              departmentName: user.departmentName || '',
              image: user.image 


          });
      
          console.log("Formulaire après patchValue :", this.form.value);
      
          this.modalService.open(this.editModal, { size: 'lg' });
      }
      
    
        /** ✅ Mise à jour de l'utilisateur avec les rôles correctement formatés */
        saveUpdatedUser() {
            console.log("Formulaire de mise à jour soumis :", this.form.value);
          
            if (this.form.invalid) {
              console.error("Le formulaire est invalide", this.form.errors);
              return;
            }
          
            const updatedUser = { ...this.form.value };
          
            // ✅ Formatage de la date
            if (updatedUser.hiringDate instanceof Date) {
              updatedUser.hiringDate = updatedUser.hiringDate.toISOString().split('T')[0];
            }
          
            // ✅ Validation et formatage des rôles
            if (!updatedUser.role || updatedUser.role.length === 0) {
              console.error("Erreur : Aucun rôle sélectionné !");
              return;
            }
          
            if (!updatedUser.role.some((r: string) => r.startsWith('ROLE_'))) {
              updatedUser.role = updatedUser.role.map((role: string) => `ROLE_${role.toUpperCase()}`);
            }
          
            // ✅ Construction de FormData
            const formData = new FormData();
            formData.append('id', updatedUser.id);
            formData.append('username', updatedUser.username || '');
            formData.append('name', updatedUser.name || '');
            formData.append('prenom', updatedUser.prenom || '');
            formData.append('email', updatedUser.email || '');
            formData.append('phone', updatedUser.phone || '');
            formData.append('address', updatedUser.address || '');
            formData.append('site', updatedUser.site || '');
            formData.append('hiringDate', updatedUser.hiringDate || '');
            if (updatedUser.departmentIds) {
              formData.append('departmentIds', updatedUser.departmentIds);
            }          
            // ✅ Mot de passe si non vide
            if (updatedUser.password && updatedUser.password.trim() !== '') {
              formData.append('password', updatedUser.password);
            }
          
            // ✅ Ajouter chaque rôle
            updatedUser.role.forEach((role: string) => {
              formData.append('role', role);
            });
            if (this.selectedSignature) {
              formData.append('signature', this.selectedSignature);
            }

          
            console.log("FormData prêt à être envoyé");
          
            this.userService.updateUser(updatedUser.id, formData).subscribe({
              next: (response) => {
                console.log("Réponse du backend :", response);
                if (response.status) {
                  this.modalService.dismissAll();
                  this.cdr.detectChanges();
                  this.fetchUserList();
                } else {
                  console.error("Échec de la mise à jour :", response.message);
                }
              },
              error: (error) => {
                console.error("Erreur lors de la mise à jour de l'utilisateur :", error);
              }
            });
          }
          

    openEditModal(element: any) {
        console.log(element)
        this.form.patchValue(element);
        this.cdr.detectChanges(); // Force la détection des changements
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    }

    openViewModel(user: any) {
        console.log("Utilisateur sélectionné :", user);
    
        // Nettoyer et formater les rôles pour l'affichage
        let roles = user.roles ? user.roles.map((r: string) => r.replace('ROLE_', '').toLowerCase()) : [];
    
        this.form.patchValue({
            id: user.id,
            username: user.username,
            email: user.email,
            //preleveur:user.preleveur,
            name: user.name,
            prenom: user.prenom,
            phone: user.phone,
            address: user.address,
            hiringDate: user.hiringDate,
            site:user.site,
            role: roles
        });
    
        console.log("Formulaire après patchValue :", this.form.value);
    
        this.cdr.detectChanges();
        this.modalService.open(this.viewModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    }
    
    

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open('Vous etes sur de supprimer cet utilisateur?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteUser(element.id);
                }
            });
    }

deleteUser(id: number) {
  this.apiService.put(null, this.endpoints.user_endpoint + '/delete_user', id).pipe(
    tap((response: any) => {
      if (response.status) {
        this.removeTableRow(id);
        this.dialogService.openSuceessAlert('Utilisateur supprimé avec succès');
      }
    }),
    finalize(() => {
      this.dataSource.paginator = this.paginator;
    })
  ).subscribe();
}


    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(sample => sample.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchVal
    }

    handleSelection(sam: AppUserDTO) {
        this.selectedSamples.has(sam) ? this.selectedSamples.delete(sam) : this.selectedSamples.add(sam)
    }

    handleSelectAll() {
        this.isAllSamplesSelected = !this.isAllSamplesSelected
        if (this.isAllSamplesSelected) {
            this.selectedSamples = new Set<AppUserDTO>(this.dataSource.filteredData)
        } else {
            this.selectedSamples = new Set<AppUserDTO>()
        }
    }

    openModal(content: any) {
        this.form.reset()
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
            (result) => {
                if (result === 'save') {
                }
            }
        );
    }
    selectedFile!: File;
    imagePreview: string | ArrayBuffer | null = null;

    
    
    selectedSignature: File | null = null;

onFileSelected(event: any) {
  if (event.target.files && event.target.files.length > 0) {
    this.selectedSignature = event.target.files[0];

    // facultatif : vérifier le type et la taille
    const allowedTypes = ['image/png', 'image/jpeg'];
    if (!allowedTypes.includes(this.selectedSignature!.type)) {
      console.error('Type de fichier non autorisé !');
      this.selectedSignature = null;
      return;
    }
  }
}

    saveUser() {
        console.log("Formulaire soumis :", this.form.value);
      
        console.log('Erreurs du formulaire:', this.form.errors);
        Object.keys(this.form.controls).forEach(key => {
          const controlErrors = this.form.get(key)?.errors;
          if (controlErrors) {
            console.log('Erreur sur', key, ':', controlErrors);
          }
        });

        if (this.form.invalid) {
          console.error("Le formulaire n'est pas valide", this.form.errors);
          return;
        }
        const newUser = { ...this.form.value };
      
        // Format de la date d'embauche
        if (newUser.hiringDate instanceof Date) {
          newUser.hiringDate = newUser.hiringDate.toISOString().split('T')[0];
        }
      
        // Validation des rôles
        if (!newUser.role || newUser.role.length === 0) {
          console.error("Erreur : aucun rôle sélectionné !");
          return;
        }
      
        // ⚙️ Préparer FormData
        const formData = new FormData();
        formData.append('username', newUser.username || '');
        formData.append('name', newUser.name || '');
        formData.append('prenom', newUser.prenom || '');

        formData.append('email', newUser.email || '');
        formData.append('phone', newUser.phone || '');
        formData.append('address', newUser.address || '');
        formData.append('site', newUser.site || '');
        formData.append('hiringDate', newUser.hiringDate || '');
        formData.append('password', newUser.password || '');
        if (newUser.departmentIds) {
          formData.append('departmentIds', newUser.departmentIds);
      }

        // ✅ Important : envoyer une string 'true' ou 'false' pour le champ booléen
        //formData.append('preleveur', newUser.preleveur ? 'true' : 'false');
      
        // Rôles formatés
        newUser.role.forEach((role: string) => {
          formData.append('role', `ROLE_${role.toUpperCase()}`);
        });
      
        if (newUser.image && newUser.image.trim() !== '') {
          formData.append('image', newUser.image);
        }
      if (this.selectedSignature) {
        formData.append('signature', this.selectedSignature);
      }
        console.log("FormData prêt à être envoyé");
      
        this.userService.createUser(formData).subscribe({
          next: (response) => {
            console.log("Réponse du backend:", response);
            if (response.status || response.message === 'User created successfully') {
              this.modalService.dismissAll();
              this.cdr.detectChanges();
              this.fetchUserList();
            } else {
              console.error("Échec de la création de l'utilisateur:", response.message);
              this.creatingUser = false;
            }
          },
          error: (error) => {
            console.error("Erreur lors de la création de l'utilisateur:", error);
            this.creatingUser = false;
          }
        });
      }
signaturePreview?: string;

onSignatureSelected(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.selectedSignature = file;
    this.signaturePreview = URL.createObjectURL(file);
  }
}

public fetchUserList() {
  this.loadingTable = true;
  console.log("🚀 Début fetchUserList");

  this.userService.getUsers().subscribe({
    next: (response) => {
      console.log("📥 Réponse brute API:", response);

      if (response?.status && Array.isArray(response.data)) {
        console.log("✅ API status = true, nombre d'utilisateurs reçus:", response.data.length);

        this.dataSource.data = response.data.map((user: any, index: number) => {
          const deptNames = user.departmentNames?.length
            ? user.departmentNames.join(', ')
            : 'Aucun département';
          console.log(`👤 User[${index}] id=${user.id}, username=${user.username}, departmentNames:`, deptNames);

          return {
            ...user,
            departmentNames: deptNames
          };
        });

        console.log("📊 DataSource final :", this.dataSource.data);
      }

      this.loadingTable = false;
      console.log("⏱️ Loading terminé");
    },
    error: (err) => {
      console.error("❌ Erreur lors du fetchUserList :", err);
      this.handleErrors.catchError(err);
      this.loadingTable = false;
    }
  });
}


    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action']
    };

    // Handle individual checkbox changes
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`userCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const sampleCols = this.cookieService.get(`userCol_${this.user_name}`);

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); 
            console.log('Retrieved object:', sampleCols);
        }
    }
    openImportModal(importModal: any) {
        this.modalService.open(importModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }

}
